import {
  LayoutDashboard, Building2, Users, Stethoscope, Receipt, Wallet, FileBarChart, BedDouble,
  ClipboardList, UserRound, ShieldCheck,
} from "lucide-react";

export const COUNTRIES = [
  ["Kenya", "KES"], ["Uganda", "UGX"], ["Tanzania", "TZS"], ["Rwanda", "RWF"], ["Burundi", "BIF"],
  ["Ethiopia", "ETB"], ["South Sudan", "SSP"], ["Somalia", "SOS"], ["DR Congo", "CDF"], ["Nigeria", "NGN"],
  ["Ghana", "GHS"], ["South Africa", "ZAR"], ["Zambia", "ZMW"], ["Malawi", "MWK"], ["Mozambique", "MZN"],
  ["Zimbabwe", "USD"], ["Botswana", "BWP"], ["Namibia", "NAD"], ["Egypt", "EGP"], ["Morocco", "MAD"],
  ["India", "INR"], ["United Arab Emirates", "AED"], ["Saudi Arabia", "SAR"], ["United Kingdom", "GBP"],
  ["United States", "USD"], ["Canada", "CAD"], ["Germany", "EUR"], ["France", "EUR"], ["Netherlands", "EUR"],
  ["Ireland", "EUR"], ["Australia", "AUD"],
].map(([name, currency]) => ({ name, currency }));

export const CURRENCIES = [...new Set(COUNTRIES.map((c) => c.currency))].sort();

export const STAFF_ROLES = ["doctor", "nurse", "receptionist", "accountant", "dentist", "lab", "pharmacist", "hr"];

export const ROLE_LABELS = {
  super_admin: "Super Admin", ceo: "CEO / MD", manager: "Clinic Manager", doctor: "Doctor", nurse: "Nurse",
  receptionist: "Receptionist", accountant: "Accountant", dentist: "Dentist", lab: "Lab Technician",
  pharmacist: "Pharmacist", hr: "HR Officer",
};

export const CATEGORY_LABELS = {
  consultation: "Consultation", procedure: "Procedure", dental: "Dental", lab: "Laboratory", pharmacy: "Pharmacy", other: "Other",
};

export const DEPARTMENTS = { general: "General OPD", dental: "Dental Unit", procedure: "Procedures", lab: "Laboratory", pharmacy: "Pharmacy" };

export const EXPENSE_CATEGORIES = {
  salaries: "Salaries", medical_supplies: "Medical supplies", utilities: "Utilities", rent: "Rent",
  maintenance: "Maintenance", equipment: "Equipment", marketing: "Marketing", other: "Other",
};

export const METHOD_LABELS = { cash: "Cash", mpesa: "M-Pesa", card: "Card", insurance: "Insurance" };

export const roleOf = (u) => (u?.platform_role === "super_admin" ? "super_admin" : u?.role);

const I = {
  dashboard: { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  clinics: { to: "/clinics", label: "Clinics", icon: Building2 },
  staff: { to: "/staff", label: "Staff & HR", icon: Users },
  services: { to: "/services", label: "Services", icon: ClipboardList },
  patients: { to: "/patients", label: "Patients", icon: UserRound },
  visits: { to: "/visits", label: "Consultations", icon: Stethoscope },
  invoices: { to: "/invoices", label: "Invoices", icon: Receipt },
  expenses: { to: "/expenses", label: "Expenses", icon: Wallet },
  reports: { to: "/reports", label: "Reports", icon: FileBarChart },
  inpatient: { to: "/inpatient", label: "Inpatient", icon: BedDouble, soon: true },
  admin: { to: "/admin", label: "Platform", icon: ShieldCheck },
};

export const NAV = {
  super_admin: [I.admin],
  ceo: [I.dashboard, I.clinics, I.staff, I.patients, I.invoices, I.expenses, I.reports, I.inpatient],
  manager: [I.dashboard, I.staff, I.services, I.patients, I.visits, I.invoices, I.expenses, I.reports, I.inpatient],
  accountant: [I.dashboard, I.invoices, I.expenses, I.reports, I.patients, I.services],
  receptionist: [I.dashboard, I.patients, I.visits, I.invoices, I.services],
  doctor: [I.dashboard, I.patients, I.visits, I.invoices, I.services],
  dentist: [I.dashboard, I.patients, I.visits, I.invoices, I.services],
  nurse: [I.dashboard, I.patients, I.visits, I.services],
  lab: [I.dashboard, I.patients, I.visits, I.services],
  pharmacist: [I.dashboard, I.patients, I.visits, I.services],
  hr: [I.dashboard, I.staff],
};

const PERMS = {
  createPatient: ["manager", "receptionist", "nurse", "doctor", "dentist"],
  updateVisit: ["doctor", "dentist", "nurse", "manager"],
  createInvoice: ["manager", "accountant", "receptionist", "doctor", "dentist"],
  recordPayment: ["accountant"],
  addExpense: ["accountant"],
  manageServices: ["manager"],
  manageStaff: ["manager"],
  finance: ["ceo", "manager", "accountant"],
};

export const can = (user, action) => (PERMS[action] || []).includes(roleOf(user));
